import Utils from '@/common/utils/utils';
import Constant from '../../common/constant/Constant';
import './ChatAttachment.css';
import { CircularProgress, Dialog } from '@material-ui/core';
import { useState } from 'react';
import {
    downloadFileFromS3,
    getFileSizeDisplay,
    getLinkDownloadFileFromS3
} from '../common/FileUploaded';
import { PropTypes } from 'prop-types';
import { displayTagOfThumbAttach } from '@/component/ticketKnowledge/handler/ListTicketKnowledgeHandler';

export const AttachFile = ({
    file,
    detailTicket,
    isAlignLeft,
    chatPost,
    setIsShowPopupLogout,
    isImageLayout = false
}) => {
    const [openPreviewImage, setOpenPreviewImage] = useState(null);

    const content = (file?.shortKey ? file?.fileInfo?.fileName : file?.fileData?.name) || '';
    const isImage = Utils.isImageFile(content);
    const lastDot = content.lastIndexOf('.');
    let fileExtention = '';
    let fileName;
    if (lastDot <= 0) {
        fileName = content.length > 50 ? content.slice(0, 50) + '...' : content;
    } else {
        fileExtention = content.substring(lastDot + 1);
        fileName =
            content.substring(0, lastDot).length > 50
                ? content.substring(0, lastDot).slice(0, 50) + '...'
                : content.substring(0, lastDot) + '.';
    }

    const fileNameAndSize = `${fileName}${fileExtention} (${getFileSizeDisplay(
        file?.shortKey ? file?.fileInfo?.fileSize : file?.fileData?.size
    )})`;

    const chatPostData = file?.shortKey
        ? {
              fileUrl: file.fileInfo.fileUrl,
              id: file.originId,
              type: Constant.S3_FILE_TYPE.CHAT_POST_FILE,
              chatThreadType: chatPost?.chatThreadType,
              sharedRange: chatPost?.sharedRange,
              content: file.fileInfo.fileName
          }
        : null;

    const dataDownload = file?.shortKey
        ? isImage
            ? getLinkDownloadFileFromS3(chatPostData, detailTicket)
            : null
        : file.localUrl;

    const imgThumbnailLink = file?.shortKey
        ? isImage
            ? getLinkDownloadFileFromS3(
                  { ...chatPostData, thumbnailInfo: JSON.stringify(file.thumbnailInfo) },
                  detailTicket,
                  null,
                  Constant.ATTACH_FILE.VIEW_CHAT
              )
            : null
        : file.localUrl;
    const thumbnailSrc = isImage ? imgThumbnailLink : '/assets/image/others_file.png';
    const displayTextInFile = displayTagOfThumbAttach(detailTicket || {}, content);
    const handleClickFile = () => {
        if (isImage) {
            setOpenPreviewImage(dataDownload);
            return;
        }

        if (file?.shortKey) {
            downloadFileFromS3(
                chatPostData,
                detailTicket,
                false,
                false,
                '',
                setIsShowPopupLogout
            );
        }
    };

    return (
        <div>
            {isImageLayout ? (
                <div
                    className="container-img-chatthread"
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        opacity: file?.shortKey ? 1 : 0.5,
                        position: 'relative'
                    }}
                >
                    <img
                        onClick={() => setOpenPreviewImage(dataDownload)}
                        style={{ cursor: 'pointer', borderRadius: 10, objectFit: 'cover' }}
                        height={145}
                        width={145}
                        src={imgThumbnailLink}
                        alt=""
                    />
                    {!file?.shortKey && (
                        <CircularProgress
                            size={30}
                            style={{
                                position: 'absolute',
                                inset: 0,
                                margin: 'auto'
                            }}
                        />
                    )}
                </div>
            ) : (
                <div
                    className="container-img-chatthread chat-message-file"
                    style={{
                        opacity: file?.shortKey ? 1 : 0.5
                    }}
                >
                    <div className="chat-message-file-thumbnail">
                        <img
                            onClick={handleClickFile}
                            src={thumbnailSrc}
                            alt=""
                        />
                        {!isImage && (
                            <span
                                className="chat-message-file-extension"
                                style={{ backgroundColor: displayTextInFile.colorCode }}
                            >
                                {displayTextInFile.name}
                            </span>
                        )}
                    </div>
                    <button
                        type="button"
                        className={`chat-message-file-name ${
                            isAlignLeft ? 'chat-message-file-name-left' : 'chat-message-file-name-right'
                        }`}
                        onClick={handleClickFile}
                        disabled={!file?.shortKey && !isImage}
                        title={fileNameAndSize}
                    >
                        <span className="chat-message-file-name-text">{fileNameAndSize}</span>
                    </button>
                    {!file?.shortKey && (
                        <CircularProgress
                            size={20}
                            style={{
                                position: 'absolute',
                                inset: 0,
                                margin: 'auto'
                            }}
                        />
                    )}
                </div>
            )}
            <Dialog
                open={!!openPreviewImage}
                onClose={() => setOpenPreviewImage(null)}
                maxWidth="md"
            >
                <img
                    alt=""
                    src={openPreviewImage}
                    style={{
                        maxWidth: '90vw',
                        maxHeight: '90vh',
                        objectFit: 'contain'
                    }}
                />
            </Dialog>
        </div>
    );
};

AttachFile.propTypes = {
    file: PropTypes.any,
    detailTicket: PropTypes.any,
    isAlignLeft: PropTypes.any,
    chatPost: PropTypes.any,
    setIsShowPopupLogout: PropTypes.any,
    isImageLayout: PropTypes.bool
};
